import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { ObservacionTutorExDTO } from '../../../../core/models/titulacion/observacionTutorEx-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class ObservacionTutorExService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getObservacionTutorExService() {
        return this.http.get<BodyListResponse<ObservacionTutorExDTO>>(
            API_URL + '/api/v1/observacionTutorEx/todos'
        );
    }

    guardarObservacionTutorExService(observacionTutorExDTO: ObservacionTutorExDTO) {
        return this.http.post(API_URL + '/api/v1/observacionTutorEx', observacionTutorExDTO);
    }

    getObservacionTutorExPorCodigoObservacionTutorExService(codigoObservacionTutorEx: string) {
        return this.http.get<BodyResponse<ObservacionTutorExDTO>>(
            API_URL + '/api/v1/observacionTutorEx/' + codigoObservacionTutorEx
        );
    }
}
